var _a, _b;
import { __decorate, __metadata } from "tslib";
import { Action, Mutation, Module, VuexModule } from 'vuex-module-decorators';
import { Actions, Mutations } from '@/store/enums/StoreEnums';
let BreadcrumbsModule = class BreadcrumbsModule extends VuexModule {
    constructor() {
        super(...arguments);
        this.breadcrumbs = {};
    }
    /**
     * Get breadcrumb object for current page
     * @returns object
     */
    get getBreadcrumbs() {
        return this.breadcrumbs;
    }
    /**
     * Get breadcrumb array for current page
     * @returns object
     */
    get pageBreadcrumbPath() {
        if (!this.breadcrumbs)
            return [];
        return this.breadcrumbs.pageBreadcrumbPath;
    }
    /**
     * Get current page title
     * @returns string
     */
    get pageTitle() {
        if (!this.breadcrumbs)
            return '';
        return this.breadcrumbs.title;
    }
    ['ResetBreadCrumbs']() {
        this.breadcrumbs = '';
    }
    [_a = Mutations.SET_BREADCRUMB_MUTATION](payload) {
        if (!payload || typeof payload == 'undefined')
            return;
        this.breadcrumbs = payload;
    }
    [_b = Actions.SET_BREADCRUMB_ACTION](payload) {
        this.context.commit(Mutations.SET_BREADCRUMB_MUTATION, payload);
    }
};
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], BreadcrumbsModule.prototype, 'ResetBreadCrumbs', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], BreadcrumbsModule.prototype, _a, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], BreadcrumbsModule.prototype, _b, null);
BreadcrumbsModule = __decorate([
    Module
], BreadcrumbsModule);
export default BreadcrumbsModule;
